import { CalendarEvent } from 'utils'

export type GreedyFillResult = {
	visibleEvents: CalendarEvent[]
	hiddenEvents: CalendarEvent[]
	visibleEffectiveSlots: number
}

export function greedyFill(
	events: CalendarEvent[],
	maxQuantityElement: number
): GreedyFillResult {
	let totalSlots = 0
	events.forEach(e => {
		totalSlots += e.has_notification ? 2 : 1
	})

	const maxSlotsForEvents =
		totalSlots <= maxQuantityElement
			? maxQuantityElement
			: maxQuantityElement - 1

	let remainingSlots = maxSlotsForEvents
	const visibleEvents: CalendarEvent[] = []
	events.forEach(e => {
		const cost = e.has_notification ? 2 : 1
		if (remainingSlots >= cost) {
			visibleEvents.push(e)
			remainingSlots -= cost
		}
	})

	const hiddenEvents = events.filter(e => !visibleEvents.includes(e))
	const visibleEffectiveSlots = visibleEvents.reduce(
		(acc, e) => acc + (e.has_notification ? 2 : 1),
		0
	)

	return { visibleEvents, hiddenEvents, visibleEffectiveSlots }
}
